export default [
  {
    header: 'Pages',
    icon: 'FileIcon',
    children: [
      {
        title: 'dashbord',
        route: 'dashboard',
        icon: 'HomeIcon',
      },
      {
        title: 'Products',
        route: 'products',
        icon: 'FileIcon',
      },
    ],
  },
]
